module.exports = __webpack_public_path__ + "img/SingleLineText.4f9c3467.svg";